import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'templates'
const verb = 'get'

export default class OspreyTemplatesGetById extends BaseAction {
    constructor(dataKey, onError) {
        const id = 'b064c1b0-f8f2-4e7e-8662-0f2fe9bc1506'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true

        this.onError = onError
    }

    getById(templateId, ownerOrn, fetchLatest = false) {
        this.path = `/${resource}/${templateId}`
        this.params = {
            ownerOrn,
            fetchLatest
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/templates/templates-get-by-id.js